import { convertHourStringToMinutes } from './convert-hour-string-to-minute'

export function convertPeriod(periods) {
  const weekdays = {
    SUNDAY: 'Domingo',
    MONDAY: 'Segunda-feira',
    TUESDAY: 'Terça-feira',
    WEDNESDAY: 'Quarta-feira',
    THURSDAY: 'Quinta-feira',
    FRIDAY: 'Sexta-feira',
    SATURDAY: 'Sábado',
  }

  const keysWeekdays = Object.keys(weekdays)

  const formatWeekdays = keysWeekdays
    ?.map((day) => periods.find((period) => period.openDay === day || period.closeDay === day))
    ?.map((period, index) => {
      return !period
        ? {
            openDay: keysWeekdays[index],
            openTime: 'Fechado',
            closeDay: keysWeekdays[index],
            closeTime: 'Fechado',
          }
        : period
    })

  const handleFormatTime = (value) => {
    if (typeof value === 'string') return value

    let { hours = '0', minutes } = value

    if (!hours || hours === 24) hours = '23'

    return (
      String(hours).padStart(2, '0') +
      (minutes ? `:${String(minutes).padStart(2, '0')}` : hours === '23' ? ':59' : ':00')
    )
  }

  const getFormatTime = (period) => {
    return `${handleFormatTime(period.openTime)} - ${handleFormatTime(period.closeTime)}`
  }

  const mappedWeekdays = formatWeekdays.map(
    (period) =>
      `${weekdays[period.openDay || period.closeDay]}, ${
        typeof period.openTime === 'string' ? handleFormatTime(period.openTime) : getFormatTime(period)
      }`,
  )

  const day = new Date().getDay()
  const currentDay = mappedWeekdays[day]?.split(',')

  const currentTime = `${new Date().getHours()}:${new Date().getMinutes()}`
  // eslint-disable-next-line no-unsafe-optional-chaining
  const [startTime, endTime] = currentDay[1]?.trim()?.split('-')

  const currentTimeInMinutes = convertHourStringToMinutes(currentTime)
  const startTimeInMinutes = convertHourStringToMinutes(startTime)
  const endTimeMinutes = convertHourStringToMinutes(endTime)

  return {
    weekdays: mappedWeekdays,
    startTime: startTime.trim(),
    endTime: endTime.trim(),
    isOpen: currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeMinutes,
  }
}
